import React from 'react';
import { useSelector } from 'react-redux';

import ScoutMessagesList from '../../../../scout-new/components/message-output/MessagesList';

import scss from './MessagesList.module.scss';

function MessagesList({ isShowResponseForm }) {
  const collectDataMessages = useSelector((state) => state.scout.collectDataMessages);

  return (
    <div className={scss.tableWrapper}>
      <ScoutMessagesList
        content={collectDataMessages}
        isActionsDisabled
        maxHeight={isShowResponseForm ? 'calc(100vh - 520px)' : 'calc(100vh - 205px)'}
      />
    </div>
  );
}

export default MessagesList;
